<template>
  <v-app light class="body-content">
    <AutoReload></AutoReload>
    <Snackbar ref="globalInfo" :text="globalInfo" textColor="orange--text"></Snackbar>
    <Snackbar ref="errorMsg" :text="errorMsg" textColor="red--text"></Snackbar>
    <div v-if="!userIsAuthenticated || $route.name === 'confirmPasswordReset'">
      <v-toolbar color="#00476B">
        <img src="@/assets/icons/lpf_icon.png" height="50" class="pointer">
        <ToolbarLogo></ToolbarLogo>
      </v-toolbar>
      <confirm-password-recovery v-if="$route.name === 'confirmPasswordReset'"></confirm-password-recovery>
      <Login v-else></Login>
    </div>
    <div v-else>
      <nav>
        <ToolbarNav></ToolbarNav>
        <LateralNav></LateralNav>
      </nav>
      <v-content>
        <v-container fluid>
          <router-view></router-view>
        </v-container>
      </v-content>
    </div>
    <v-footer app absolute inset color="#00476B">
      <v-card class="flex footer-element pa-0" flat color="#00476B">
        <v-card-actions class="justify-center pt-1">
          <div class="white--text">
            {{ currentVersion }}
          </div>
        </v-card-actions>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import Login from '../features/account/components/Login'
import ConfirmPasswordRecovery from '../features/account/views/ConfirmPasswordRecovery'
import LateralNav from '../common/layout/lateral/LateralNav'
import Snackbar from '../common/ui/Snackbar'
import ToolbarNav from '../common/layout/toolbar/ToolbarNav'
import ToolbarLogo from '../common/layout/toolbar/ToolbarLogo'
import AutoReload from '../common/ui/AutoReload'

export default {
  name: 'App',

  components: {
    LateralNav,
    Login,
    Snackbar,
    ToolbarNav,
    ToolbarLogo,
    AutoReload,
    ConfirmPasswordRecovery
  },

  data () {
    return {
      lateralMenu: null,
      globalInfo: '',
      errorMsg: ''
    }
  },

  computed: {
    userIsAuthenticated () {
      return this.$store.state.jwt && (this.$store.state.userRole != null)
    },
    currentVersion () {
      return process.env.VUE_APP_RELEASE || 'LPF (dev)'
    }
  },

  created () {
    // Por si se actualiza la pagina o se cierra y se vuelve a abrir
    this.$store.commit('updateHeader')
  },

  watch: {
    '$store.state.globalInfo' () {
      if (this.$store.state.globalInfo) {
        this.globalInfo = this.$store.state.globalInfo
        if (this.$refs.hasOwnProperty('globalInfo')) this.$refs.globalInfo.showSnackbar()
      }
      this.$store.commit('cleanGlobalInfo')
    },
    '$store.state.errorMsg' () {
      if (this.$store.state.errorMsg) {
        this.errorMsg = this.$store.state.errorMsg
        if (this.$refs.hasOwnProperty('errorMsg')) this.$refs.errorMsg.showSnackbar()
      }
      this.$store.commit('cleanErrorMsg')
    },
    '$store.state.draft' () {
      if (this.$store.getters.hasDraftInProgress) {
        this.$store.commit('changeshowDraftNotification', true)
      }
    }
  }
}
</script>

<style scoped>
.body-content {
  background-color: #eaeaea;
}
.footer-element {
  background: #293968;
  margin-top: 2px;
}
</style>
